import { useAppStore, selectStatusText } from '@/store';
import { useOfflineStatus } from '@/hooks/useOfflineStatus';
import { WifiOff } from 'lucide-react';
import styles from './StatusBar.module.css';

export function StatusBar() {
  const statusText = useAppStore(selectStatusText);
  const isOffline = useOfflineStatus();

  return (
    <footer className={styles.statusBar}>
      <span>{statusText}</span>
      {isOffline && (
        <span className={styles.offline}>
          <WifiOff size={14} style={{ verticalAlign: 'middle', marginRight: '0.25rem' }} />
          Offline
        </span>
      )}
    </footer>
  );
}
